import styled from 'styled-components';

export const StrategyHeader = styled.div`
  div {
    display: inline;
  }
`;
